import { setBusy, setToastMessage } from "../components/app/actions";

// Common API function interceptor
export const api = (path, options, dispatch) => {
  dispatch(setBusy({ busy: true }));
  return fetch(path, {
    ...options,
    method: options.method,
    credentials: "same-origin",
    headers: new Headers({
      "Content-Type": "application/json",
      ...options.headers,
    }),
  })
    .then(async (resp) => {
      dispatch(setBusy({ busy: false }));
      if (resp.ok){
        if(resp.headers.get("content-type") === "application/pdf"){
          return resp
        }
        const res = await resp.json();
        return res
      }else{
        const res = await resp.json();
        if(res && res?.message){
          dispatch(
            setToastMessage({
              message: res.message,
              type: "error",
            })
          );
        }
      }
      throw await resp.json();
    })
    .finally(() => dispatch(setBusy({ busy: false })));
};
